import { Typography } from "@mui/material";
import React from "react";
import { AdminListContext } from "./context/adminListContext";
import AdminListProps from "./interface/adminListProps";
import AdminProps from "./interface/adminProps";
import RenderTopBar from "./src/renderTopBar";
import RenderList from "./src/renderList";
import AddAdminDialog from "./src/addAdmin/addAdminDialog";
import RevokeAdminDialog from "./src/revokeAdminDialog";

const AdminListContainer = (): React.JSX.Element => {
  const {
    adminList,
    addAdmin,
    revokeAdmin,
  }: {
    adminList: AdminListProps;
    addAdmin: boolean;
    revokeAdmin: AdminProps | null;
  } = React.useContext(AdminListContext);

  if (adminList.loading)
    return <Typography variant="h4">Lade Admins...</Typography>;

  return (
    <React.Fragment>
      <RenderTopBar />
      <RenderList />

      {addAdmin && <AddAdminDialog />}
      {revokeAdmin && <RevokeAdminDialog />}
    </React.Fragment>
  );
};

export default AdminListContainer;
